import pxToRem from "assets/theme/functions/pxToRem";
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";
import borders from "assets/theme/base/borders";
import boxShadows from "assets/theme/base/boxShadows";

const { white, grey } = colors;
const { size } = typography;
const { borderRadius } = borders;

export default {
  styleOverrides: {
    popper: {
      backgroundColor: "transparent",
      boxShadow: "none",
      padding: 0,
    },

    paper: {
      backgroundColor: colors.inputColors.backgroundColor,
      borderRadius: borderRadius.lg,
      border: `0.5px solid ${grey[600]}`,
      boxShadow: boxShadows.lg,
      padding: 0,
      overflow: "hidden",
    },

    listbox: {
      padding: pxToRem(4),
      backgroundColor: "transparent",
    },

    option: {
      minHeight: pxToRem(34),
      padding: `${pxToRem(6)} ${pxToRem(12)}`,
      borderRadius: borderRadius.md,
      fontSize: "12px",
      color: grey[300],
      transition: "background-color 200ms ease, color 200ms ease",

      "&:hover": {
        backgroundColor: "rgba(255,255,255,0.12)",
        color: white.main,
      },

      "&.Mui-focused": {
        backgroundColor: "rgba(255,255,255,0.15)",
        color: white.main,
      },

      '&[aria-selected="true"]': {
        backgroundColor: "rgba(255,255,255,0.18)",
        color: white.main,
      },
    },

    tag: {
      height: pxToRem(26),
      borderRadius: borderRadius.md,
      backgroundColor: "rgba(255,255,255,0.15)",
      border: "1px solid rgba(255,255,255,0.15)",
      color: white.main,
    },
  },
};
